import { TableCell, TableHead, TableRow, TextField } from '@mui/material';
import React from 'react';
import TableCellComponent from '../table-cell';

export function TableHeadComponent({ tableCells, showFilter = false, filters = {}, onFilterChange = () => {}, }) {
  return (
    <TableHead>
      {showFilter ? (
        <>
          <TableRow>
            {tableCells &&
              tableCells.length > 0 &&
              tableCells.map((t, index) => (
                <TableCell key={'filter-' + index + t.id}>
                  {t.filterable ? (
                  <TextField
                    variant="standard"
                    placeholder={`Filter ${t.title}`}
                    value={filters[t.id] || ''}
                    onChange={(e) => onFilterChange(t.id, e.target.value)}
                    fullWidth
                  />
                  ) : (
                    <>{t.title}</>
                  )}
                </TableCell>
              ))}
          </TableRow>

        </>
      ) : (<>
        <TableRow>
          {tableCells &&
            Object.keys(tableCells).length > 0 &&
            tableCells.map((t, index) => {
              // if (t.id === 'contentBookId') return null

              return (
                <TableCellComponent
                  key={index + t.id}
                  sx={{ fontWeight: 600 }}
                  cellData={t.title}
                />
              );
            })}
        </TableRow>
      </>)}
    </TableHead>
  );
}
